import { Injectable } from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ProductsListViewService {
    private isGridViewSubscription: Subscription;
    private isGridViewSubject = new Subject<boolean>();

    public isGridView: boolean = false;

    public isGridViewObservable(): Observable<boolean> {
        return this.isGridViewSubject.pipe();
    }

    public constructor() {
        this.isGridViewSubscription = this.isGridViewObservable()
            .subscribe(value => this.isGridView = value);
    }

    public setGridView(): void {
        this.isGridViewSubject.next(true);
    }

    public setListView(): void {
        this.isGridViewSubject.next(false);
    }
}
